<script setup lang="ts">
// ヒーロー（アイキャッチ + リード文 + 注釈 + 調査概要リンク）
</script>

<template>
  <section class="hero">
    <h1 class="hero-eyecatch">
      <img
        src="~/assets/images/ranking/hero_eyecatch_pc.png"
        alt="保険スクエアbang! 火災保険ランキング 2026年版"
        width="640"
        height="308"
      />
    </h1>

    <div class="hero-body">
      <p class="hero-lead">
        当サービス利用者へのアンケートをもとに、現在加入している火災保険会社をランキングで紹介します。住宅条件によって最適な保険は異なるため、ランキングを参考にしてください。
      </p>
      <p class="hero-note">
        <span class="hero-note-mark">※</span
        ><span>当社での契約順ではなく、利用者の現在の加入状況を集計したものです。</span>
      </p>
      <a
        class="hero-surveyLink"
        href="#research-overview"
        v-smooth-scroll="{ duration: 300, offset: -60 }"
        >■調査概要</a
      >
    </div>
  </section>
</template>

<style lang="scss" scoped>
.hero {
  display: flex;
  flex-direction: column;
}

.hero-eyecatch {
  img {
    width: 100%;
    height: auto;
  }
}

.hero-body {
  padding: 15px 15px 35px;
}

.hero-lead {
  font-size: px(13);
  line-height: 20px;
  color: $colorBasicText;
}

.hero-note {
  margin-top: 8px;
  font-size: px(12);
  line-height: 1.5;
  color: $colorCompareGray;
}

.hero-note-mark {
  margin-right: 0.1em;
}

.hero-surveyLink {
  margin-top: 8px;
  display: inline-block;
  font-size: px(12);
  color: #148cde;
  text-decoration: none;
}

@include media(pc) {
  .hero {
    gap: 31px;
  }

  .hero-body {
    padding: 0 0 53px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .hero-lead {
    font-size: px(15);
    line-height: 22px;
  }

  .hero-note,
  .hero-surveyLink {
    margin-top: 0;
  }
}
</style>
